import React from 'react';
import ContentRenderer from '../../components/common/ContentRenderer';
import termsAndConditionsData from '../../data/termsAndConditions.json';
import { ContentDocument } from '../../types/contentTypes';

interface TermsAndConditionsProps {}

const TermsAndConditions: React.FC<TermsAndConditionsProps> = () => {
  return (
    <ContentRenderer 
      data={termsAndConditionsData as ContentDocument}
      contactEmail="admin@thesampark.com"
      showContactInfo={true}
      headerAlignment="center"
      maxWidth="lg"
      showLogo={true}
      logoSrc="/images/sampark-logo.png"
      logoAlt="Sampark Logo"
    />
  );
};

export default TermsAndConditions;